/**
 * Photos used on the public website, with the attribution their licences require.
 * Sourced from Wikimedia Commons; CC0 images need no credit but are listed for completeness.
 */
export interface ImageCredit {
  file: string;
  title: string;
  author: string;
  license: string;
  licenseUrl: string;
  source: string;
}

export const IMAGE_CREDITS: ImageCredit[] = [
  {
    file: 'students',
    title: 'CCET-Bhilai students',
    author: 'Jinothomaskalol',
    license: 'CC BY-SA 3.0',
    licenseUrl: 'https://creativecommons.org/licenses/by-sa/3.0',
    source: 'https://commons.wikimedia.org/wiki/File:CCET-Bhilai_students.JPG',
  },
  {
    // file: 'electrician',
    file: 'skilled service',
    title: 'Electrician at work, Goa, India',
    author: 'Fredericknoronha',
    license: 'CC BY-SA 4.0',
    licenseUrl: 'https://creativecommons.org/licenses/by-sa/4.0',
    source: 'https://commons.wikimedia.org/wiki/File:Electrician_at_work,_Goa,_India.jpg',
  },
  {
    // file: 'heavy-industry',
    file: 'Steel & Manufacturing',
    title: 'Heavy industry (Unsplash)',
    author: 'Ant Rozetsky',
    license: 'CC0',
    licenseUrl: 'http://creativecommons.org/publicdomain/zero/1.0/deed.en',
    source: 'https://commons.wikimedia.org/wiki/File:Heavy_industry_(Unsplash).jpg',
    // source: 'Steel & Manufacturing.png',
  },
  {
    // file: 'construction',
    file: 'Construction & Infra',
    title: 'Male labour working at Building construction site',
    author: 'Jim Carter',
    license: 'CC BY-SA 4.0',
    licenseUrl: 'https://creativecommons.org/licenses/by-sa/4.0',
    source: 'https://commons.wikimedia.org/wiki/File:Male_labour_working_at_Building_construction_site.jpg',
  },
  {
    file: 'healthcare',
    title: 'Simulation lab',
    author: 'Raghav93',
    license: 'CC BY-SA 4.0',
    licenseUrl: 'https://creativecommons.org/licenses/by-sa/4.0',
    source: 'https://commons.wikimedia.org/wiki/File:Simulation_lab.jpg',
  },
  {
    // file: 'it-office',
    file: 'it company',
    title: 'Typing on a laptop (Unsplash)',
    author: 'Simon Hattinga Verschure',
    license: 'CC0',
    licenseUrl: 'http://creativecommons.org/publicdomain/zero/1.0/deed.en',
    source: 'https://commons.wikimedia.org/wiki/File:Typing_on_a_laptop_(Unsplash).jpg',
  },
  {
    file: 'manufacturing',
    title: 'Factory Worker Making Clothes (Unsplash)',
    author: 'Igor Ovsyannykov',
    license: 'CC0',
    licenseUrl: 'http://creativecommons.org/publicdomain/zero/1.0/deed.en',
    source: 'https://commons.wikimedia.org/wiki/File:Factory_Worker_Making_Clothes_(Unsplash).jpg',
  },
  {
    file: 'campus',
    title: 'IIT Bhilai Acad Block',
    author: 'BruceWayne1621',
    license: 'CC BY-SA 4.0',
    licenseUrl: 'https://creativecommons.org/licenses/by-sa/4.0',
    source: 'https://commons.wikimedia.org/wiki/File:IIT_Bhilai_Acad_Block.jpg',
  },
  {
    file: 'naya-raipur-office',
    title: 'Office complex block A & B , sector 24, Naya Raipur',
    author: 'VishuN',
    license: 'CC BY-SA 4.0',
    licenseUrl: 'https://creativecommons.org/licenses/by-sa/4.0',
    source: 'https://commons.wikimedia.org/wiki/File:Office_complex_block_A_%26_B_,_sector_24,_Naya_Raipur.png',
  },
  {
    // file: 'raipur-skyline',
    file: 'cg',
    title: 'Raipur Skyline 2019',
    author: 'VishuN',
    license: 'CC BY-SA 4.0',
    licenseUrl: 'https://creativecommons.org/licenses/by-sa/4.0',
    source: 'https://commons.wikimedia.org/wiki/File:Raipur_Skyline_2019.png',
  },
];

// export const homeImage = (file: string) => `/images/home/${file}.webp`;
export const homeImage = (file: string) => `/images/landingimages/${file}.png`;
